import { Col, Divider, Row, Tag } from "antd";
import Typography from "antd/es/typography/Typography";

const ProfileSubSection = ({ label, value, isChips }) => (
  <div className="profile-sub-section">
    <Typography className="profile-field-heading">{label}</Typography>
    {isChips ? (
      <Row gutter={[8, 8]} className="profile-tags-row">
        {Array.isArray(value) && value?.length > 0 ? (
          value?.map((tagValue, index) => (
            <Col xs={12} sm={8} md={2.5} key={`${tagValue}-${index}`}>
              <Tag className="location-tags">{tagValue}</Tag>
            </Col>
          ))
        ) : (
          <Typography className="profile-field-value text-black">
            No Data
          </Typography>
        )}
      </Row>
    ) : (
      <Typography className="profile-field-value text-black">
        {value}
      </Typography>
    )}
  </div>
);

export default ProfileSubSection;
